export let BillingOption = /*#__PURE__*/function (BillingOption) {
  BillingOption["outOfScope"] = "outOfScope";
  BillingOption["inAgreement"] = "inAgreement";
  return BillingOption;
}({});
export let GlobalBillModalErrorMessages = /*#__PURE__*/function (GlobalBillModalErrorMessages) {
  GlobalBillModalErrorMessages["FailedToRequestAgreements"] = "Failed to load the agreements.";
  GlobalBillModalErrorMessages["FailedToRequestServices"] = "Failed to load the services.";
  GlobalBillModalErrorMessages["FailedToRequestContacts"] = "Failed to load the contacts.";
  return GlobalBillModalErrorMessages;
}({});